import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import MainContent from './MainContent';
import ToastNotifications from './ToastNotifications';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  const [showResultsSection, setShowResultsSection] = useState(false);
  const [isConfirmClickable, setIsConfirmClickable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [textAreaValue, setTextAreaValue] = useState('');
  const [activePrompt, setActivePrompt] = useState('');
  const [isGenerateClickable, setIsGenerateClickable] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [imageUrls, setImageUrls] = useState(window.pageTemplateVariables ? window.pageTemplateVariables.imageUrls : ["https://loremflickr.com/500/500?1", "https://loremflickr.com/500/500?2", "https://loremflickr.com/500/500?3", "https://loremflickr.com/500/500?4"]);
  const [activeImage, setActiveImage] = useState(imageUrls[0]);
  let customServerUrl = window.document.location.host.indexOf('localhost') > -1 ? 'http://localhost:5000' : 'https://ai.diamondpainting.de';

  const promptButtonsData = [
    { label: 'Schöne Frau', prompt: 'Bunte schöne Frau: detailreich, elegant, weitläufig, fantastisch' },
    { label: 'Süße Katze', prompt: 'Mini süße Katze Kätzchen Hund, hyperdetailreich, schöne Naturkulisse, sehr detailliert' },
    { label: 'Bunter Baum', prompt: 'Sehr bunter und leuchtender Baum, ultradetailreiches künstlerisches Foto, träumerisch, umgeben von schwarzem Hintergrund, Farbexplosion' },
    { label: 'Mediterrane Stadt', prompt: 'Schöne und beeindruckende mediterrane Stadt im Sonnenuntergang, Ölgemälde' },
    { label: 'Abstrakte Liebe', prompt: 'Abstrakte Liebe, Regenbogenfarben, auf schöner Hintergrund' }
  ];  

  const handleGenerate = async () => {
    setShowResultsSection(true);
    setIsLoading(true);

    try {
      // Call the translation endpoint to get the translated text
      const translationResponse = await fetch(`${customServerUrl}/translate?text=${encodeURIComponent(textAreaValue)}`);
      const translationData = await translationResponse.json();
      if (translationData.error) {
        throw new Error(translationData.error);
      } else {
        const translatedText = translationData.translatedText;
        setActivePrompt(translatedText); 
        
        // Make the existing HTTP request with the updated activePrompt
        const resolution = selectedProduct?.resolution.replace('px', '').split('x').join('-');
        const prompt = encodeURIComponent(translatedText);
        const requestUrl = `${customServerUrl}/generate/${resolution}/${prompt}`;

        const generationResponse = await fetch(requestUrl);
        const response = await generationResponse.json();
        if (response.success){
          // Update the imageUrls state with the URLs from the server's response
          const images = response.data.map(item => item.url);
          setActiveImage(images[0]);
          setImageUrls(images);
          setIsConfirmClickable(true);
        } else {
          //console.log('error generating image', response.error);
          let error = response.error;
          if (error.data.error){
            error = error.data.error;
          }
          throw new Error(error);
        }
      }
    } catch (error) {
      console.error('Error fetching data ', error); 
      toast.error('Error fetching data. Please try again later. ' + error, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirm = async () => {
    const requestBody = {
      size: selectedProduct.size,
      prompt: textAreaValue,
      image: activeImage
    };

    try {
      const response = await fetch(`${customServerUrl}/confirm`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      const result = await response.json();
      if (result.success) {
        console.log('result', result);
        localStorage.setItem('ai-image', result.imageUrl);
        localStorage.setItem('ai-size', selectedProduct.size);
        window.location.href = `/products/${result.productId}`;
        console.log("Confirmation successful");
      } else {
        console.error("Error during confirmation:", result.message);
      }
    } catch (error) {
      console.error("Error sending confirmation:", error);
      toast.error('Error fetching data. Please try again later. ' + error, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }


  useEffect(() => {
    if (showResultsSection) {
      const resultsElement = document.getElementById('results-section');
      if (resultsElement) {
        resultsElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [showResultsSection]);

  useEffect(() => {
    setIsGenerateClickable(textAreaValue.trim() !== '' && selectedProduct && selectedProduct.size !== null);
  }, [textAreaValue, selectedProduct]);

  useEffect(() => {
    setActiveImage(imageUrls[0]);
  }, [imageUrls]);

  return (
    <div className="app">
      <div className="app-main">
        <Container>
          <Row>
            <MainContent
              isLoading={isLoading}
              activeImage={activeImage}
              setActiveImage={setActiveImage}
              activePrompt={activePrompt}
              imageUrls={imageUrls}
              selectedProduct={selectedProduct}
              setSelectedProduct={setSelectedProduct}
              textAreaValue={textAreaValue}
              setTextAreaValue={setTextAreaValue}
              promptButtonsData={promptButtonsData}
              isGenerateClickable={isGenerateClickable}
              isConfirmClickable={isConfirmClickable}
              handleGenerate={handleGenerate}
              handleConfirm={handleConfirm}
            />
          </Row>
        </Container>
        <ToastNotifications />
      </div>
    </div>
  );
}

export default App;